import { z } from 'zod';
import { uuid, isoDateTime } from './common.js';
export const userStatus = z.enum(['active', 'disabled']);
/** The printers at a user's packing table (Christmas packing); empty means the plan's. */
export const userPrinters = z.object({ labelPrinterId: uuid.nullable(), smallLabelPrinterId: uuid.nullable(), documentPrinterId: uuid.nullable() });
export const userDto = z.object({
    id: uuid,
    email: z.string(),
    name: z.string(),
    locale: z.enum(['da', 'en']),
    status: userStatus,
    roles: z.array(z.string()),
    warehouseScope: z.array(uuid).nullable(),
    printers: userPrinters,
    totpEnabled: z.boolean(),
    lastLoginAt: isoDateTime.nullable(),
    createdAt: isoDateTime,
});
export const createUserRequest = z.object({
    email: z.string().trim().toLowerCase().email(),
    name: z.string().trim().min(1).max(120),
    locale: z.enum(['da', 'en']).default('da'),
    roles: z.array(z.string()).min(1),
    warehouseScope: z.array(uuid).nullable().default(null),
    printers: userPrinters.optional(),
    /** When omitted an invitation with a set-password link is created. */
    password: z.string().min(12).max(200).optional(),
});
export const updateUserRequest = z.object({
    name: z.string().trim().min(1).max(120).optional(),
    locale: z.enum(['da', 'en']).optional(),
    status: userStatus.optional(),
    roles: z.array(z.string()).min(1).optional(),
    warehouseScope: z.array(uuid).nullable().optional(),
    printers: userPrinters.optional(),
});
//# sourceMappingURL=users.js.map